import { HttpErrorResponse } from '@angular/common/http';

import { PrismicData } from '@dav-model/api/response/prismic-response.model';

import * as PrismicActions from '../../store/prismic/prismic.actions';

export interface State {
  data: PrismicData;
  loading: boolean;
  error: HttpErrorResponse;
}

const InitialState: State = {
  data: undefined,
  loading: false,
  error: undefined,
};

export function reducer(state = InitialState, action: PrismicActions.All): State {
  switch (action.type) {
    case PrismicActions.LOAD_PRISMIC_DATA: {
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    }

    case PrismicActions.LOAD_PRISMIC_DATA_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: undefined,
      };
    }

    case PrismicActions.LOAD_PRISMIC_DATA_FAILURE: {
      return {
        ...state,
        error: undefined,
        loading: false,
      };
    }

    default: {
      return state;
    }
  }
}
